<template>
	<Col>
		<PdfViewerLegacy v-if="isLegacyMode" :pdfSrc="src" v-on="$listeners" />
		<Row v-else class="flex-centerize mr-16">
			<DocumentsViewer :documents="src" v-on="$listeners" />
		</Row>
	</Col>
</template>

<script>
import DocumentsViewer from './DocumentsViewer.vue';
import PdfViewerLegacy from './PdfViewer.legacy.vue';
export default {
	name: 'PdfViewerHandler',
	components: { DocumentsViewer, PdfViewerLegacy },
	props: {
		src: { type: [String, Array] },
		isMultiFileViewer: { type: Boolean },
	},
	computed: {
		isLegacyMode() {
			return !this.isMultiFileViewer;
		},
	},
};
</script>
<style scoped lang="scss"></style>
